import { render, staticRenderFns } from "./RunStatus.vue?vue&type=template&id=2c2489cd&scoped=true&"
import script from "./RunStatus.vue?vue&type=script&lang=ts&"
export * from "./RunStatus.vue?vue&type=script&lang=ts&"
import style0 from "./RunStatus.vue?vue&type=style&index=0&id=2c2489cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2489cd",
  null
  
)

export default component.exports